/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Passwordstrengthcompromised2Inputs */

const en_passwordstrengthcompromised2 = /** @type {(inputs: Passwordstrengthcompromised2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compromised`)
};

const de_passwordstrengthcompromised2 = /** @type {(inputs: Passwordstrengthcompromised2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kompromittiert`)
};

/**
* | output |
* | --- |
* | "Compromised" |
*
* @param {Passwordstrengthcompromised2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const passwordstrengthcompromised2 = /** @type {((inputs?: Passwordstrengthcompromised2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Passwordstrengthcompromised2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_passwordstrengthcompromised2(inputs)
	return de_passwordstrengthcompromised2(inputs)
});
export { passwordstrengthcompromised2 as "passwordStrengthCompromised" }